import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';

import { faStar, IconDefinition, faStarHalf } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarO } from "@fortawesome/free-regular-svg-icons";


@Component({
    selector: 'rating',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <span *ngIf="hasRating(); else noRating" [title]="rating">
            <fa-icon *ngFor="let star of star(rating)" [icon]="iconStar"></fa-icon><!--
         --><fa-icon *ngIf="(rating || 0) % 1 !== 0" [icon]="iconStarHalf"></fa-icon><!--
         --><ng-container *ngIf="max"><!--
            --><fa-icon *ngFor="let a of fakeArray()" [icon]="iconStarO"></fa-icon>
            </ng-container>
        </span>

        <ng-template #noRating>
            <em>{{ wording.noRating }}</em>
        </ng-template>

    `,
    styles: [`
        span{
            white-space: nowrap;
        }
        em {
            color: #666;
        }
    `]
})
export class RatingComponent {
    @Input()
    public rating: number = 3.5;

    @Input()
    public max: number;

    public iconStar: IconDefinition = faStar;

    public iconStarHalf: IconDefinition = faStarHalf;
    public iconStarO: IconDefinition = faStarO;

    public wording: ILabels = {
        noRating: Yii.t("wui-shared-js", "Classement indisponible"),
    };

    public star(rating: number): number[] {
        if (!rating) {
            return [];
        }

        const starsArray: number[] = rangeStars(Number(rating));

        const decimal: number = Number(rating) - starsArray.length;

        if (decimal > 0) {
            starsArray.push(decimal - 1);
        }
        return starsArray;
    }

    public fakeArray(): undefined[] {
        const rating: number = Number(this.rating) || 0;

        return new Array(Math.max(0, Math.floor(Number(this.max) - rating))).fill(undefined);
    }

    public hasRating(): boolean {
        return this.rating !== null && this.rating !== undefined && !isNaN(Number(this.rating));
    }
}

function rangeStars(stars: number): number[] {
    if (!stars || typeof  stars !== 'number') {
        return [];
    }

    return new Array(Math.max(1, Math.floor(stars - 1)))
        .fill(0)
        .map((value: number, index: number) => index + 1);
}
